import {UI} from "../../../stemjs/src/ui/UIBase.js";
import {BlogEntryStore} from "../../../establishment/blog/js/state/BlogStore.js";
import {BlogEntryPreview} from "../../../establishment/blog/js/BlogPanel.jsx";

export class InlineBlogPreview extends UI.Element {
    render() {
        let entries = [];

        let blogEntries = BlogEntryStore.all().sort((a, b) => {
            return b.getArticle().dateCreated - a.getArticle().dateCreated;
        });

        for (let entry of blogEntries) {
            entries.push(<BlogEntryPreview key={entry.id} entryId={entry.id} urlPrefix="/blog/" style={{marginBottom: "-20px !important",}}/>);
        }

        return entries;
    }
}